define('webshopMenuLocaleView',[
  'module',
  'marionette',
  'underscore',
  'template!webshopMenuLocaleView'
], function (
  Module,
  Marionette,
  _,
  Tpl
) {
  'use strict';

  // Form of a ModalView: language whose menu is copied (model.locale)
  Module.exports = Marionette.ItemView.extend({
    template: Tpl,
    className: 'webshop-menu-locale-view',

    events: {
      'change select': 'onChange'
    },

    serializeData: function () {
      return {
        locales: this.options.locales || [],
        locale: this.model.get('locale')
      };
    },

    onChange: function (e) {
      this.model.set('locale', $(e.currentTarget).val());
    }
  });
});

